import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import SvgButton from '../../../../components/SvgButton';

const CtaBanner = props => {
  const {
    blockWidth = '100%',
    blockHeight = 'auto',
    blockText = 'Cta Text',
    blockBg = '',
    blockColor = '#fff',
    blockFontSize = '1rem',
    btnText = 'Learn More',
    btnLink = '/employers',
  } = props;

  const styles = {
    backgroundImage: 'url(' + blockBg + ')',
    width: blockWidth + 'px',
    height: blockHeight + 'px',
  };

  return (
    <div className="cta-block" style={styles}>
      <h3
        className="cta-block__text"
        style={{
          color: blockColor,
          fontSize: blockFontSize,
        }}
      >
        {blockText}
      </h3>
      <SvgButton
        btnWidth={150}
        btnHeight={40}
        btnFontWeight={500}
        btnHref={btnLink}
        btnText={btnText}
        btnArrow={false}
      />
    </div>
  );
};

CtaBanner.propTypes = {
  blockWidth: PropTypes.string,
  blockHeight: PropTypes.string,
  blockText: PropTypes.string,
  blockBg: PropTypes.string,
  blockColor: PropTypes.string,
  blockFontSize: PropTypes.string,
  btnText: PropTypes.string,
  btnLink: PropTypes.string,
};

export default CtaBanner;
